

class VscError extends Error {
    constructor(message:string) {
        super(message);
    }
}

export default VscError;